import React, { Component, Fragment } from "react";
import InlineError from "../InlineError";
import { Input } from "reactstrap";
import { connect } from "react-redux";
import { login } from "../../Reducers/Login/LoginReducer";
import { properties } from "../../constants/Propertise";
import { ClearLocalStorage } from "../../config/ClearLocalStorage";
import Overlay from "../Overlay";
import ForgetPassword from "./ForgetPassword";
import preval from "preval.macro";
import { applicatonCache } from "../../Pages/Common/Cache";
import LoginOtp from "./LoginOtp";
import { history } from "../../history";
import AlertMessages from "../AlertMessages";
import base64 from "base-64";
import {
  loadCaptchaEnginge,
  LoadCanvasTemplateNoReload,
  validateCaptcha,
} from "react-simple-captcha";
import axios from "axios";
import { Auth } from "../../auth";
import {
  setBackgroundColorRevise,
  setHeaderBackgroundColourRevise,
} from "../../Reducers/ThemeOptions";
// import themeConfig from "../themeConfig";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { api } from "../../api/api";

class LoginPageNew extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);

    this.state = {
      username: "",
      password: "",
      tandc: false,
      errors: {},
      loginRequest: false,
      isCapsLock: false,
      showForgetPasswordPopup: false,
      token: localStorage.getItem("token"),
      inpageLoadingPending: true,
      inpageLoadingError: false,
      inpageLoadingSucess: false,
      showInPageAlertModel: false,
      message: "",
      userDetails: {},
      captchaCodeGenerated: "",
      captchaCode: "",
      theme: "light",
      showPassword: false,
      otp: "",
      otpResultError: false,
      otpResultPending: false,
      otpResultSuccess: false,
      otpMessage: "",
      showOtpMessageModel: false,
      isUsernameReadOnly: false,
    };
    ClearLocalStorage.clearStorage();
    applicatonCache.deleteAllCacheData();
  }

  componentDidMount() {
    // localStorage.clear();
    // loadCaptchaEnginge(5, '#e0f2f1', 'black');
    // Checking for the user choice theme in local storage
    const preferredTheme = localStorage.getItem("preferredTheme");
    if (preferredTheme) {
      this.setState({ theme: preferredTheme });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.otpResultSuccess !== this.state.otpResultSuccess) {
      if (this.state.otpResultSuccess) {
        setTimeout(() => {
          this.setState({
            showOtpMessageModel: false,
          });
        }, 1000);
      }
    }

    if (prevState.inpageLoadingError !== this.state.inpageLoadingError) {
      if (this.state.inpageLoadingError) {
        setTimeout(() => {
          this.setState({
            showInPageAlertModel: false,
          });
        }, 1000);
      }
    }

    if (
      prevState.byPassinpageLoadingError !== this.state.byPassinpageLoadingError
    ) {
      if (this.state.byPassinpageLoadingError) {
        setTimeout(() => {
          this.setState({
            byPassshowInPageAlertModel: false,
          });
        }, 1000);
      }
    }

    if (prevState.inpageLoadingSucess !== this.state.inpageLoadingSucess) {
      if (this.state.inpageLoadingSucess) {
        this.setState({
          username: "",
          password: "",
          captchaCode: "",
        });
        // loadCaptchaEnginge(5, "#e0f2f1", "black");
      }
    }

    if (
      prevState.byPassinpageLoadingSucess !==
      this.state.byPassinpageLoadingSucess
    ) {
      if (this.state.byPassinpageLoadingSucess) {
        history.push(`${process.env.PUBLIC_URL}/welcome`);
      }
    }

    const { theme } = this.state;
    const root = document.documentElement;

    // Apply theme styles based on the theme configuration
    // if (themeConfig[theme]) {
    //   Object.entries(themeConfig[theme]).forEach(([property, value]) => {
    //     root.style.setProperty(property, value);
    //   });
    // } else {
    //   // Fallback to the default theme
    //   Object.entries(themeConfig.default).forEach(([property, value]) => {
    //     root.style.setProperty(property, value);
    //   });
    // }
    localStorage.setItem("preferredTheme", theme);
  }

  // Method to validate form Input on login page (Client side)
  validate = (data) => {
    const errors = {};
    if (!data.username) errors.username = properties.userNameRequired;
    if (!data.password) errors.password = properties.passwordRequired;
    if (data.tandc === false) {
      errors.tandc = properties.tandcRequired;
    }

    // if (this.state.napAccess === "true") {
    //   if (!data.captchaCode) errors.captchaCode = properties.captchaCodeReqText;
    //   if (
    //     data.captchaCode !== "" &&
    //     validateCaptcha(data.captchaCode, false) === false
    //   ) {
    //     errors.captchaCode = properties.captchaCodeValidReqText;
    //   }
    // }
    return errors;
  };

  // Method to handle Change form Input on login page (Client side)
  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
    if (event.target.name === "username" || event.target.name === "password") {
      this.setState({
        napAccess: "false",
        captchaCode: "",
      });
    }
  }

  handleOtpChange = (event) => {
    let value = event.target.value;
    this.setState({
      ...this.state,
      otp: value,
    });
  };

  closeOtpMessageModel = () => {
    this.setState({
      showOtpMessageModel: false,
    });
  };

  generateOTP = () => {
    let otpUrl = `${process.env.REACT_APP_API_URL}OTP/v1/emailOTP`;

    const otpReqBody = {
      username: this.state.username.toLowerCase(),
    };

    api
      .post(otpUrl, otpReqBody)
      .then((resendOtpResult) => {
        console.log("API Response:", resendOtpResult.data); // Log the full response

        if (resendOtpResult.status === 200) {
          if (
            resendOtpResult.data ===
            "OTP Request Limit Exceeded, Please Contact Admin (Limit: 3 Times)"
          ) {
            this.setState({
              otpResultError: true,
              otpResultPending: false,
              otpResultSuccess: false,
              otpMessage: resendOtpResult.data,
              showOtpMessageModel: true,
            });
          } else if (resendOtpResult.data === "User Does Not Exist") {
            this.setState({
              otpResultError: true,
              otpResultPending: false,
              otpResultSuccess: false,
              otpMessage: resendOtpResult.data,
              showOtpMessageModel: true,
            });
          } else if (
            resendOtpResult.data ===
            "Cannot Send OTP: Wrong Login Attempt Limit Exceeded, Please Contact Admin"
          ) {
            this.setState({
              otpResultError: true,
              otpResultPending: false,
              otpResultSuccess: false,
              otpMessage: "Too many attempts Please contact Admin.",
              showOtpMessageModel: true,
              alertColor: "red", // Set alert color to red
            });
          } else if (
            resendOtpResult.data ===
            "OTP Request Limit Exceeded, Please Contact Admin (Limit: 5 Times)"
          ) {
            this.setState({
              otpResultError: true,
              otpResultPending: false,
              otpResultSuccess: false,
              otpMessage: "Too many attempts Please contact Admin.",
              showOtpMessageModel: true,
              alertColor: "red", // Set alert color to red
            });
          } else {
            this.setState({
              otpResultError: false,
              otpResultPending: false,
              otpResultSuccess: true,
              otpMessage: resendOtpResult.data,
              otp: "", // Replace with actual OTP retrieval if possible
              showOtpMessageModel: true,
            });
            console.log("OTP has been sent to your email.");
          }
        } else {
          this.setState({
            otpResultError: true,
            otpResultPending: false,
            otpResultSuccess: false,
            otpMessage: properties.globalErrorMessage,
            showOtpMessageModel: true,
          });
        }
      })
      .catch((error) => {
        this.setState({
          otpResultError: true,
          otpResultPending: false,
          otpResultSuccess: false,
          otpMessage: properties.globalErrorMessage,
          showOtpMessageModel: true,
        });
      });
  };
  otpCheckData = (event) => {
    event.preventDefault();
    const errors = this.validateOtpData(this.state);
    this.setState({ errors });
    if (Object.keys(errors).length === 0) {
      // this.props.login(this.state);
      // this.setState({ loginRequest: true });
      // this.forceUpdate();

      this.otpFormData(this.state);
      // this.credentialsValidation(this.state)
    }
  };

  validateOtpData = (data) => {
    const errors = {};
    if (!data.otp) errors.otp = properties.otpRequired;
    if (!data.username) errors.username = properties.userNameRequired;
    if (!data.password) errors.password = properties.passwordRequired;
    if (data.tandc === false) {
      errors.tandc = properties.tandcRequired;
    }
    return errors;
  };

  otpFormData = async () => {
    const { username, password, otp } = this.state;
    // let loginUrl = `${process.env.REACT_APP_API_URL}OTP/v1/validateOTP/${otp}`;
    let loginUrl = `${process.env.REACT_APP_API_URL}validateOTPAndUnifiedLogin/${otp}`;
    const loginObj = {
      username: username.toLowerCase(),
      password: password,
    };

    let headers = new Headers();
    headers.append(
      "Authorization",
      "Basic " +
        base64.encode(loginObj["username"] + ":" + loginObj["password"])
    );
    let requestOptions = {
      method: "GET",
      headers: headers,
      redirect: "follow",
    };
    this.setState({
      // byPassloginRequest: true,
      loginRequest: true,
      byPassinpageLoadingPending: true,
      byPassinpageLoadingError: false,
      byPassinpageLoadingSucess: false,
    });

    fetch(loginUrl, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let details = JSON.parse(result);
        if (details["errorCode"] === undefined) {
          const roles = details["roles"];
          if (roles.includes("SuperAdminRole")) {
            roles.push("NAT_ADMIN_ROLE");
          }
          localStorage.setItem(
            "onevubasicauthtoken",
            details["basicAuthToken"]
          );
          localStorage.setItem("refreshToken", details["bearerToken"]);
          localStorage.setItem("onevuusername", details["username"]);
          localStorage.setItem("selectedLang", "En");
          localStorage.setItem("defaultLang", "En");
          localStorage.setItem("selectedProject", 1);
          localStorage.setItem(
            "oneviewprojects",
            JSON.stringify(details["unifiedproject"])
          );
          localStorage.setItem("roles", JSON.stringify(details["roles"]));

          Auth.authenticateUser(
            loginObj.username,
            loginUrl,
            details["basicAuthToken"]
          );
          Auth.updateUserInformation(details);

          if (details["userPreferences"] !== null) {
            let { id, sidebarTheme, headerTheme } = details["userPreferences"];
            localStorage.setItem("id", id);
            localStorage.setItem("oneviewheaderTheme", headerTheme);
            localStorage.setItem("oneviewsiderbarTheme", sidebarTheme);

            this.props.setHeaderBackgroundColourRevise(headerTheme);
            this.props.setBackgroundColorRevise(sidebarTheme);
            this.setState({
              loginRequest: false,
              byPassshowInPageAlertModel: true,
              byPassinpageLoadingPending: false,
              byPassinpageLoadingError: false,
              byPassinpageLoadingSucess: true,
            });
          } else {
            localStorage.setItem("id", null);
            localStorage.setItem(
              "oneviewheaderTheme",
              "bg-info header-text-light"
            );
            localStorage.setItem(
              "oneviewsiderbarTheme",
              "bg-night-sky sidebar-text-light"
            );

            // this.props.setHeaderBackgroundColourRevise('bg-night-sky header-text-light')
            // this.props.setBackgroundColorRevise('bg-royal sidebar-text-light');
          }
          this.props.setLoginSuccess(details["bearerToken"], true, true);
        } else {
          this.setState({
            loginRequest: false,
            byPassshowInPageAlertModel: true,
            byPassinpageLoadingPending: false,
            byPassinpageLoadingError: true,
            byPassinpageLoadingSucess: false,
            message: "Invalid Credentials",
          });
          this.props.setLoginError(properties.userLoginError);
        }
      })
      .catch((error) => {
        console.log("error", error);
        console.log("Error message:", error.message);
        console.log("Props: ", this.props); // Log props to check

        let errorMessage;
        // Check for the specific error message in the error
        if (error.message.includes("setLoginError is not a function")) {
          errorMessage = "Invalid OTP.";
        } else if (
          error.message.includes("Wrong Login Attempt Limit Exceeded")
        ) {
          errorMessage = "Too many attempts. Please contact Admin";
        } else if (error.message.includes("Unexpected token 'W'")) {
          // Handle the unexpected token error specifically
          errorMessage = "Too many attempts. Please contact Admin";
        } else {
          errorMessage = "Invalid Credentials";
        }

        this.setState(
          {
            loginRequest: false,
            byPassshowInPageAlertModel: true,
            byPassinpageLoadingPending: false,
            byPassinpageLoadingError: true,
            byPassinpageLoadingSucess: false,
            message: errorMessage,
          },
          () => {
            console.log("message", this.state.message); // Log the updated message
          }
        );
      });
  };

  postformData = (event) => {
    event.preventDefault();
    const errors = this.validate(this.state);
    this.setState({ errors });
    if (Object.keys(errors).length === 0) {
      this.byPassMfa(this.state);
    }
  };

  byPassMfa = (loginData) => {
    this.setState({
      loginRequest: true,
      inpageLoadingPending: true,
    });
    let loginUrl = `${process.env.REACT_APP_API_URL}checkAccessType`;
    axios
      .post(loginUrl, {
        username: loginData.username,
      })
      .then((result) => {
        if (result.status === 200) {
          if (result.data.MFA === "True") {
            this.setState(
              {
                napAccess: "true",
                loginRequest: false,
                inpageLoadingPending: false,
              },
              () => {
                this.generateOTP();
              }
            );
            // const errors = this.validate(this.state);
            // this.setState({ errors });

            // if (Object.keys(errors).length === 0) {
            //   this.credentialsValidation(this.state);
            // }
          } else {
            this.setState(
              {
                napAccess: "false",
              },
              () => this.handleByPassMfa(this.state)
            );
          }
        } else {
          this.setState({
            username: "",
            password: "",
            showInPageAlertModel: true,
            inpageLoadingPending: false,
            inpageLoadingError: true,
            inpageLoadingSucess: false,
            message: properties.globalErrorMessage,
          });
        }
      })
      .catch((error) => {
        this.setState({
          username: "",
          password: "",
          captchaCode: "",
          showInPageAlertModel: true,
          inpageLoadingPending: false,
          inpageLoadingError: true,
          inpageLoadingSucess: false,
          message: properties.globalErrorMessage,
        });
      });
  };

  handleByPassMfa = async (loginData) => {
    this.setState({
      // byPassloginRequest: true,
      loginRequest: true,
      byPassinpageLoadingPending: true,
      byPassinpageLoadingError: false,
      byPassinpageLoadingSucess: false,
    });
    try {
      let loginUrl =
        process.env.REACT_APP_USERMANAGEMENT_API_URL + "unifiedlogin";
      const loginObj = {
        username: loginData.username.toLowerCase(),
        password: loginData.password,
      };
      const headers = {
        Authorization:
          "Basic " +
          base64.encode(loginObj["username"] + ":" + loginObj["password"]),
        "Content-Type": "application/json",
      };
      const config = {
        headers: headers,
      };
      const { data, status } = await axios.get(loginUrl, config);

      if (status === 200) {
        console.log("basicAuthToken", data["basicAuthToken"]);
        localStorage.setItem("onevubasicauthtoken", data["basicAuthToken"]);
        localStorage.setItem("refreshToken", data["bearerToken"]);
        localStorage.setItem("onevuusername", data["username"]);
        localStorage.setItem("selectedLang", "En");
        localStorage.setItem("defaultLang", "En");
        localStorage.setItem("selectedProject", 1);
        localStorage.setItem(
          "oneviewprojects",
          JSON.stringify(data["unifiedproject"])
        );
        localStorage.setItem("roles", JSON.stringify(data["roles"]));

        Auth.authenticateUser(
          data["username"],
          loginUrl,
          data["basicAuthToken"]
        );
        Auth.updateUserInformation(data);

        if (data["userPreferences"] !== null) {
          let { id, sidebarTheme, headerTheme } = data["userPreferences"];
          localStorage.setItem("id", id);
          localStorage.setItem("oneviewheaderTheme", headerTheme);
          localStorage.setItem("oneviewsiderbarTheme", sidebarTheme);

          this.props.setHeaderBackgroundColourRevise(headerTheme);
          this.props.setBackgroundColorRevise(sidebarTheme);
        } else {
          localStorage.setItem("id", null);
          localStorage.setItem(
            "oneviewheaderTheme",
            "bg-info header-text-light"
          );
          localStorage.setItem(
            "oneviewsiderbarTheme",
            "bg-night-sky sidebar-text-light"
          );

          // this.props.setHeaderBackgroundColourRevise('bg-night-sky header-text-light')
          // this.props.setBackgroundColorRevise('bg-royal sidebar-text-light');
        }

        this.setState({
          loginRequest: false,
          byPassshowInPageAlertModel: true,
          byPassinpageLoadingPending: false,
          byPassinpageLoadingError: false,
          byPassinpageLoadingSucess: true,
        });
      }
    } catch (error) {
      console.log(error);
      this.setState({
        loginRequest: false,
        byPassshowInPageAlertModel: true,
        byPassinpageLoadingPending: false,
        byPassinpageLoadingError: true,
        byPassinpageLoadingSucess: false,
        message: "Invalid Credentials",
      });
    }
  };

  capLock = (event) => {
    if (event.getModifierState("CapsLock") === true) {
      this.setState({ isCapsLock: true });
    } else {
      this.setState({ isCapsLock: false });
    }
  };

  openForgetPasswordPopup = () => {
    this.setState({
      showForgetPasswordPopup: true,
    });
  };

  closeForgetPasswordPopup = () => {
    this.setState({
      showForgetPasswordPopup: false,
    });
  };

  handleCheckbox = (event) => {
    if (event.target.checked === true) {
      this.setState({
        tandc: true,
      });
    } else {
      this.setState({
        tandc: false,
      });
    }
  };

  closeOTPPopup = () => {
    localStorage.clear();
    this.setState({
      showOTPPopup: false,
    });
  };

  closeInPageAlertModel = () => {
    this.setState({
      showInPageAlertModel: false,
    });
  };

  closeInPageByPassAlertModel = () => {
    this.setState({
      byPassshowInPageAlertModel: false,
    });
  };

  togglePasswordVisibility = () => {
    this.setState((prevState) => ({
      showPassword: !prevState.showPassword,
    }));
  };

  render() {
    const { username, password, errors, captchaCode, showPassword } =
      this.state;
    let bgPath = process.env.PUBLIC_URL + "/images/loginbg.png";

    return (
      <Fragment>
        <div
          className="loginContainer"
          style={{ backgroundImage: `url(${bgPath})` }}
        >
          <Overlay
            title={properties.forgetPassText}
            openOverlay={this.state.showForgetPasswordPopup}
            closeOverlay={this.closeForgetPasswordPopup}
          >
            <ForgetPassword
              closeForgetPasswordPopup={this.closeForgetPasswordPopup}
            />
          </Overlay>

          <div className="tata-yr-logo"></div>

          <div className="container">
            <div className="InnerLogin">
              <div className="form-row">
                <div className="col-md-12 mb-3">
                  <div className="login-panel">
                    <div
                      className="row"
                      style={{ textAlign: "center", display: "block" }}
                    >
                      <span className="logimg">
                        <img
                          src={`${process.env.PUBLIC_URL}/images/logo-login.png`}
                          className="login-logo-form1"
                          alt=""
                        />
                      </span>
                    </div>

                    <div className="row">
                      <span className="col-md-12 app_name_span">
                        {properties.projectName}
                      </span>
                    </div>
                    <form
                      onSubmit={this.postformData}
                      noValidate
                      className="col-md-12 mb-3"
                    >
                      <div className="col-md-12 mb-3">
                        <Input
                          type="text"
                          name="username"
                          id="username"
                          value={username}
                          placeholder="Username"
                          onChange={this.handleChange}
                          readOnly={this.state.otpResultSuccess}
                          style={{
                            backgroundColor: this.state.otpResultSuccess
                              ? "#f0f0f0"
                              : "white",
                            cursor: this.state.otpResultSuccess
                              ? "not-allowed"
                              : "text",
                          }}
                        />
                        {errors.username && (
                          <InlineError text={errors.username} />
                        )}
                      </div>
                      <div className="col-md-12 mb-3 position-relative">
                        <Input
                          type={showPassword ? "text" : "password"}
                          name="password"
                          id="password"
                          placeholder="Password"
                          value={password}
                          onKeyPress={this.capLock.bind(this)}
                          onChange={this.handleChange}
                        />
                        {password && (
                          <span
                            className="position-absolute"
                            style={{
                              top: "20%",
                              right: "8%",
                              cursor: "pointer",
                              fontSize: "16px",
                            }}
                            onClick={this.togglePasswordVisibility}
                          >
                            <FontAwesomeIcon
                              icon={showPassword ? faEyeSlash : faEye}
                            />
                          </span>
                        )}
                        {errors.password && (
                          <InlineError text={errors.password} />
                        )}
                        {this.state.isCapsLock && (
                          <InlineError text={properties.capsLockMessageText} />
                        )}
                      </div>

                      {this.state.otpResultSuccess === true ? (
                        <>
                          <div className="col-md-12 mb-3">
                            <Input
                              type="text"
                              name="otp"
                              placeholder="Enter OTP"
                              value={this.state.otp}
                              onChange={this.handleOtpChange}
                              valid={
                                this.state.errors.otp === undefined &&
                                this.state.otp !== "" &&
                                this.state.isValid === true
                                  ? true
                                  : false
                              }
                              invalid={
                                this.state.errors.otp !== undefined
                                  ? true
                                  : false
                              }
                            />
                            {this.state.errors.otp && (
                              <InlineError text={this.state.errors.otp} />
                            )}
                            <h7>
                              <a
                                className="forgetpassword"
                                // onClick={this.handleResendOTP}
                                onClick={this.generateOTP}
                              >
                                resend otp
                              </a>
                            </h7>
                          </div>
                        </>
                      ) : null}

                      <div className="col-md-12 mb-3">
                        <span style={{ marginLeft: "20px" }}>
                          <Input
                            type="checkbox"
                            name="tandc"
                            id="tandc"
                            onChange={this.handleCheckbox.bind(this)}
                          />
                          &nbsp;
                          <span className="forgetpassword">
                            {properties.tandcmessage}
                          </span>
                          <a
                            className="forgetpassword"
                            href={`${process.env.PUBLIC_URL}/images/updatedTermsOfUse.pdf`}
                            target="_blank"
                            style={{ textDecoration: "underline" }}
                          >
                            {properties.tandcText}
                          </a>
                          <br />
                          {errors.tandc && <InlineError text={errors.tandc} />}
                        </span>
                      </div>

                      {this.state.otpResultSuccess === false ? (
                        this.state.loginRequest ? (
                          this.state.inpageLoadingPending === true ? (
                            <div className="loginLoadingMessage">
                              {properties.loginPendingMessge}
                            </div>
                          ) : (
                            <Fragment>
                              <div className="col-md-12 mb-3">
                                <button
                                  type="button"
                                  color="primary"
                                  className="mb-2 mr-2 btn btn-primary btn-lg btn-block"
                                  onClick={this.postformData}
                                >
                                  {properties.loginText}
                                </button>
                                <h6>
                                  <a
                                    className="forgetpassword"
                                    onClick={this.openForgetPasswordPopup}
                                  >
                                    {properties.forgetPasswordText}
                                  </a>
                                </h6>
                              </div>
                            </Fragment>
                          )
                        ) : (
                          <Fragment>
                            <div className="col-md-12 mb-3">
                              <button
                                // type="submit"
                                color="primary"
                                className="mb-2 mr-2 btn btn-primary btn-lg btn-block"
                                onClick={this.postformData}
                              >
                                {properties.loginText}
                              </button>
                              <h6>
                                <a
                                  className="forgetpassword"
                                  onClick={this.openForgetPasswordPopup}
                                >
                                  {properties.forgetPasswordText}
                                </a>
                              </h6>
                            </div>
                          </Fragment>
                        )
                      ) : null}

                      {this.state.otpResultSuccess === true ? (
                        <>
                          <Fragment>
                            <div className="col-md-12 mb-3">
                              <button
                                type="button"
                                color="primary"
                                className="mb-2 mr-2 btn btn-primary btn-lg btn-block"
                                // onClick={this.otpFormData}
                                onClick={this.otpCheckData}
                              >
                                {properties.loginText}
                              </button>

                              <h6>
                                <a
                                  className="forgetpassword"
                                  onClick={this.openForgetPasswordPopup}
                                >
                                  {properties.forgetPasswordText}
                                </a>
                              </h6>
                            </div>
                          </Fragment>
                        </>
                      ) : null}
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <img
              src={`${process.env.PUBLIC_URL}/images/Tata-Group-Logo-White.png`}
              alt=""
              className="img-responsive tata-yr-img-logo"
            />
            <img
              src={`${process.env.PUBLIC_URL}/images/tctslogo.png`}
              alt=""
              className="img-responsive login-logo"
            />
          </div>

          <div className="copyright-textData">
            <p className="login_copyright">{properties.footerText}</p>
          </div>
        </div>

        <Overlay
          title={properties.loginSecondFactorAuthenticationText}
          openOverlay={this.state.showOTPPopup}
          closeOverlay={this.closeOTPPopup}
        >
          <LoginOtp userDetails={this.state.userDetails} />
        </Overlay>

        <Overlay
          openOverlay={this.state.showInPageAlertModel}
          closeOverlay={this.closeInPageAlertModel}
          className="alertData"
        >
          <AlertMessages
            isSucess={this.state.inpageLoadingSucess}
            isPending={this.state.inpageLoadingPending}
            apiError={this.state.inpageLoadingError}
            showAlert={this.state.showInPageAlertModel}
            closeAlert={this.closeInPageAlertModel}
            message={this.state.message}
          />
        </Overlay>

        <Overlay
          openOverlay={this.state.byPassshowInPageAlertModel}
          closeOverlay={this.closeInPageByPassAlertModel}
          className="alertData"
        >
          <AlertMessages
            isSucess={this.state.byPassinpageLoadingSucess}
            isPending={this.state.byPassinpageLoadingPending}
            apiError={this.state.byPassinpageLoadingError}
            showAlert={this.state.byPassshowInPageAlertModel}
            closeAlert={this.closeInPageByPassAlertModel}
            message={this.state.message}
          />
        </Overlay>

        <Overlay
          openOverlay={this.state.showOtpMessageModel}
          closeOverlay={this.closeOtpMessageModel}
          className="alertData"
        >
          <AlertMessages
            isSucess={this.state.otpResultSuccess}
            isPending={this.state.otpResultPending}
            apiError={this.state.otpResultError}
            showAlert={this.state.showOtpMessageModel}
            closeAlert={this.closeOtpMessageModel}
            message={this.state.otpMessage}
          />
        </Overlay>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isLoginSuccess: state.loginData.isLoginSuccess,
    isLoginPending: state.loginData.isLoginPending,
    loginError: state.loginData.loginError,
    authDone: state.loginData.authDone,
    userToken: state.loginData.userToken,
    apiError: state.loginData.apiError,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    login: (loginData) => dispatch(login(loginData)),

    setBackgroundColorRevise: (siderbarTheme) =>
      dispatch(setBackgroundColorRevise(siderbarTheme)),
    setHeaderBackgroundColourRevise: (headerTheme) =>
      dispatch(setHeaderBackgroundColourRevise(headerTheme)),
  };
};

const getBuildDateString = () => {
  const buildTimestamp = preval`module.exports = new Date();`;

  const formattedDate = Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
  }).format(new Date(buildTimestamp));

  return formattedDate;
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginPageNew);
